<template>
	<div class="user-container">
		<div v-if="file != null" class="img-container">
			<img :src="file" alt="..." id="output" class="comprobante" />
		</div>
		<div class="loader-container" v-if="uploading && uploadProgress !== 100 && uploadProgress !== 0">
			<v-progress-circular
				:size="100"
				:width="15"
				:value="uploadProgress"
				color="#e6e6e6"
			>
				{{ uploadProgress }}%
			</v-progress-circular>
		</div>
		<div class="user-message">
			{{ message }}
		</div>
	</div>
</template>

<script>
export default {
	props: {
		data: Object,
	},
	computed: {
		file: {
			get() {
				return this.data.type == "file" ? this.data.file : null;
			},
		},
		message: {
			get() {
				return this.data.msg;
			},
		},
		uploadProgress() {
			return this.$store.getters["chatStore/get_uploading"].uploadProgress;
		},
        uploading: {
            get() {
                return this.data.uploading
            }
        }
	},
};
</script>

<style lang="scss">
.loader-container {
	position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    backdrop-filter: blur(5px);
    -webkit-backdrop-filter: blur(5px);
    border-radius: 16px;
}
.user-container {
    position: relative;
	background-color: var(--secondary-app-button);
	color: var(--app-button-text);
	display: block;
	float: right;
	margin: 10px 0;
	padding: 10px;
	border-radius: 16px;
	.comprobante {
		max-width: 200px;
		height: auto;
	}
}
</style>
